class TabsAccordion {
    constructor(selector) {
      this.tabsAccordion = document.querySelector(selector);
      this.tabButtons = this.tabsAccordion.querySelectorAll('.tab-links');
      this.tabPanels = this.tabsAccordion.querySelectorAll('.tab-panel');
      this.accordionButtons = this.tabsAccordion.querySelectorAll('.tab-links-mob');
      
      // Initialize the tabs
      this.tabButtons.forEach((button, index) => {
        button.addEventListener('click', (event) => {
          event.preventDefault();
          this.showTab(index);
        });
      });
      
      // Initialize the accordion
      this.accordionButtons.forEach((button, index) => {
        button.addEventListener('click', (event) => {
          event.preventDefault();
          this.toggleAccordion(index);
        });
      });
    }
    
    showTab(index) {
      this.tabButtons.forEach(button => {
        button.classList.remove('active');
      });
      this.tabPanels.forEach(panel => {
        panel.classList.remove('active');
      });
      this.tabButtons[index].classList.add('active');
      this.tabPanels[index].classList.add('active');
    }
    
    toggleAccordion(index) {
      this.tabPanels[index].classList.toggle('active');
    }
  }

  const tabsAccordion = new TabsAccordion('.custom-collection-menu-tabs');